/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPDimensionMapping = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ERPDimensionMapping model module.
   * @module model/ERPDimensionMapping
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPDimensionMapping</code>.
   * @alias module:model/ERPDimensionMapping
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>ERPDimensionMapping</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPDimensionMapping} obj Optional instance to populate.
   * @return {module:model/ERPDimensionMapping} The populated <code>ERPDimensionMapping</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('AccountingDimension1')) {
        obj['AccountingDimension1'] = ApiClient.convertToType(data['AccountingDimension1'], 'String');
      }
      if (data.hasOwnProperty('AccountingDimension2')) {
        obj['AccountingDimension2'] = ApiClient.convertToType(data['AccountingDimension2'], 'String');
      }
      if (data.hasOwnProperty('AccountingDimension3')) {
        obj['AccountingDimension3'] = ApiClient.convertToType(data['AccountingDimension3'], 'String');
      }
      if (data.hasOwnProperty('AccountingDimension4')) {
        obj['AccountingDimension4'] = ApiClient.convertToType(data['AccountingDimension4'], 'String');
      }
      if (data.hasOwnProperty('Dimension1SyncHandleTypeID')) {
        obj['Dimension1SyncHandleTypeID'] = ApiClient.convertToType(data['Dimension1SyncHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension2SyncHandleTypeID')) {
        obj['Dimension2SyncHandleTypeID'] = ApiClient.convertToType(data['Dimension2SyncHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension3SyncHandleTypeID')) {
        obj['Dimension3SyncHandleTypeID'] = ApiClient.convertToType(data['Dimension3SyncHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension4SyncHandleTypeID')) {
        obj['Dimension4SyncHandleTypeID'] = ApiClient.convertToType(data['Dimension4SyncHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension1SyncTargetRegisterID')) {
        obj['Dimension1SyncTargetRegisterID'] = ApiClient.convertToType(data['Dimension1SyncTargetRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension2SyncTargetRegisterID')) {
        obj['Dimension2SyncTargetRegisterID'] = ApiClient.convertToType(data['Dimension2SyncTargetRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension3SyncTargetRegisterID')) {
        obj['Dimension3SyncTargetRegisterID'] = ApiClient.convertToType(data['Dimension3SyncTargetRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension4SyncTargetRegisterID')) {
        obj['Dimension4SyncTargetRegisterID'] = ApiClient.convertToType(data['Dimension4SyncTargetRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('AccountingDimension5')) {
        obj['AccountingDimension5'] = ApiClient.convertToType(data['AccountingDimension5'], 'String');
      }
      if (data.hasOwnProperty('AccountingDimension6')) {
        obj['AccountingDimension6'] = ApiClient.convertToType(data['AccountingDimension6'], 'String');
      }
      if (data.hasOwnProperty('Dimension5SyncHandleTypeID')) {
        obj['Dimension5SyncHandleTypeID'] = ApiClient.convertToType(data['Dimension5SyncHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension6SyncHandleTypeID')) {
        obj['Dimension6SyncHandleTypeID'] = ApiClient.convertToType(data['Dimension6SyncHandleTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension5SyncTargetRegisterID')) {
        obj['Dimension5SyncTargetRegisterID'] = ApiClient.convertToType(data['Dimension5SyncTargetRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('Dimension6SyncTargetRegisterID')) {
        obj['Dimension6SyncTargetRegisterID'] = ApiClient.convertToType(data['Dimension6SyncTargetRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} AccountingDimension1
   * @default ''
   */
  exports.prototype['AccountingDimension1'] = '';
  /**
   * @member {String} AccountingDimension2
   * @default ''
   */
  exports.prototype['AccountingDimension2'] = '';
  /**
   * @member {String} AccountingDimension3
   * @default ''
   */
  exports.prototype['AccountingDimension3'] = '';
  /**
   * @member {String} AccountingDimension4
   * @default ''
   */
  exports.prototype['AccountingDimension4'] = '';
  /**
   * @member {Integer} Dimension1SyncHandleTypeID
   */
  exports.prototype['Dimension1SyncHandleTypeID'] = undefined;
  /**
   * @member {Integer} Dimension2SyncHandleTypeID
   */
  exports.prototype['Dimension2SyncHandleTypeID'] = undefined;
  /**
   * @member {Integer} Dimension3SyncHandleTypeID
   */
  exports.prototype['Dimension3SyncHandleTypeID'] = undefined;
  /**
   * @member {Integer} Dimension4SyncHandleTypeID
   */
  exports.prototype['Dimension4SyncHandleTypeID'] = undefined;
  /**
   * @member {Integer} Dimension1SyncTargetRegisterID
   */
  exports.prototype['Dimension1SyncTargetRegisterID'] = undefined;
  /**
   * @member {Integer} Dimension2SyncTargetRegisterID
   */
  exports.prototype['Dimension2SyncTargetRegisterID'] = undefined;
  /**
   * @member {Integer} Dimension3SyncTargetRegisterID
   */
  exports.prototype['Dimension3SyncTargetRegisterID'] = undefined;
  /**
   * @member {Integer} Dimension4SyncTargetRegisterID
   */
  exports.prototype['Dimension4SyncTargetRegisterID'] = undefined;
  /**
   * @member {String} AccountingDimension5
   * @default ''
   */
  exports.prototype['AccountingDimension5'] = '';
  /**
   * @member {String} AccountingDimension6
   * @default ''
   */
  exports.prototype['AccountingDimension6'] = '';
  /**
   * @member {Integer} Dimension5SyncHandleTypeID
   */
  exports.prototype['Dimension5SyncHandleTypeID'] = undefined;
  /**
   * @member {Integer} Dimension6SyncHandleTypeID
   */
  exports.prototype['Dimension6SyncHandleTypeID'] = undefined;
  /**
   * @member {Integer} Dimension5SyncTargetRegisterID
   */
  exports.prototype['Dimension5SyncTargetRegisterID'] = undefined;
  /**
   * @member {Integer} Dimension6SyncTargetRegisterID
   */
  exports.prototype['Dimension6SyncTargetRegisterID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


